import {
    call,
    put,
    take,
    select
} from 'redux-saga/effects';
import {
    debug,
    error
} from '../utils/logger';
import {
    SAYT_SEARCH,
    ENHANCED_SAYT_SEARCH,
    saytSearchResults,
    enhancedSaytSearchResults
} from '../actions/headerActions.js';
import { shouldShowNoResultsMessage } from '../utils/saytUtils';
import { usingPwaHeader } from '../utils/headerUtils';
import apiRoutes from '../utils/apiRoutes';
import {
    makeRequest
} from './makeRequest';

/* eslint-disable angular/json-functions */

export function* enhancedSaytSearchSaga() {
    let action = {};
    debug('Saga: saytSearchSaga initialized');

    while (action = yield take(ENHANCED_SAYT_SEARCH)) { // eslint-disable-line no-cond-assign
        try {
            debug(`enhanced SAYT payload: ${JSON.stringify(action.payload)}`);
            const state = yield select();
            const saytOrchestrationRoute = apiRoutes.saytOrchestration(state, action.payload.searchTerm);

            const searchSuggestions = yield call(makeRequest, saytOrchestrationRoute);
            const keywords = _.get(searchSuggestions, 'keywords', []);
            const products = _.get(searchSuggestions, 'popularProducts', []);
            const defaultProducts = _.get(searchSuggestions, 'defaultPopularProducts', []);
            let defaultTrending = _.get(searchSuggestions, 'defaultTrending', []);
            if (!defaultTrending.length) {
                // fallback to contentful if service return svc returns no default terms
                defaultTrending = _.get(state, 'core.featureConfigs.headerFeatureConfig.saytDefaultTrendingTerms', []);
            }
            const trending = _.get(searchSuggestions, 'trending', []);
            const searchTerm = _.get(searchSuggestions, 'searchTerm');
            const popularDisplayName = _.get(searchSuggestions, 'popularDisplayName');

            const data = {
                keywords: keywords,
                defaultTrending: defaultTrending,
                trending: trending,
                defaultPopularProducts: defaultProducts,
                popularProducts: products,
                searchTerm: searchTerm,
                popularDisplayName: popularDisplayName
            };

            yield put(enhancedSaytSearchResults(data,
                                                products,
                                                action.payload.source,
                                                {},
                                                shouldShowNoResultsMessage(state, action.payload.searchTerm, data)));

        } catch (err) {
            console.log(err);
            error(`Error getting enhanced SAYT results: ${err}.`);
        }
    }
}

export function* saytSearchSaga() {
    let action = {};
    debug('Saga: saytSearchSaga initialized');

    while (action = yield take(SAYT_SEARCH)) { // eslint-disable-line no-cond-assign
        try {
            debug(`SAYT payload: ${JSON.stringify(action.payload)}`);
            const searchSuggestions = yield call(getSearchSuggestionsSaga, action.payload.searchTerm);
            const products = yield call(getProducts, action.payload.searchTerm);

            yield put(saytSearchResults(searchSuggestions,
                                        products,
                                        action.payload.source,
                                        {},
                                        searchSuggestions.length <= 0));

        } catch (err) {
            console.log(err);
            error(`Error getting SAYT results: ${err}.`);
        }
    }
}

export function* getSearchSuggestionsSaga(searchTerm) {
    const state = yield select();
    const route = {
        method: 'GET',
        path: `/api/catalog/v0/${state.core.siteId}/sayt/products/keywords/searches`,
        params: { q: searchTerm },
        cacheTTL: 0
    };
    const results = yield call(makeRequest, route);
    return _(results.result.searchTerms).map(r => r.value)
                                        .value();
}

// TODO: UW-788, need updated endpoint from groupby
export function* getProducts(searchTerm) {
    return [];
}

/**
 * Returns SAYT sagas when PWA header is not enabled
 * @returns {Array} SAYT Search Sagas if applicable
 */
export function getSaytSagas() {
    if (usingPwaHeader()) {
        return [];
    }

    return [saytSearchSaga, enhancedSaytSearchSaga];
}

/* eslint-enable angular/json-functions */
